<template>
  <div class="productListing" style="width: 100%;padding-top:45px;
    position: relative;">
      <div class="filter_product_list" v-if="merchandiseProductList.length > 0">
        <!-- <h3 class="section_heading" v-if="title">{{title}}</h3> -->
        <div
          ref="container"
          class="filter_card"
          v-for="(product, index) in merchandiseProductList"
          :key="index"
          
        >
          <div
            class="img_wrapper spinner_wrapper"
            v-lazyload
            v-if="product.displayImage"
            @click="goToProductDetail(product.sellerItemRelationshipId)"
          >
            <ImageSpinner class="image_spinner" />
            <img :data-url="product.displayImage" alt />
          </div>
          <div class="product_detail">
            <p class="product-name">{{ product.productName }}</p>

            <div class="my_price_section flx">
              <span class="my_price"
                ><span class="rupee-font">₹​</span>​{{
                  product.sellingPrice
                }}</span
              >
              <span
                class="selling_price"
                v-if="
                  parseFloat(product.mrp) > parseFloat(product.sellingPrice)
                "
                ><span class="rupee-font">₹​</span>​{{ product.mrp }}</span
              >
            </div>
            <label class="price-less-tag" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPrice)">{{$t('lessWithXPrice',{lessAmount:Math.round(parseFloat(product.mrp)-parseFloat(product.sellingPrice))})}} </label>
            
            <p class="bought" style="color: black">
              {{$t('shop')}} -
              <span style="color: green">{{
                product.sellerLiteDTO.storeName
              }}</span>
            </p>
            <p v-if="product.gmallProductId" @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
              <p v-else>
                <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
          </div>
        </div>
      </div>
      <NoDataFound v-if="merchandiseProductStatus" class="no_record" />
      <infinite-loading @infinite="getProductsListing" spinner="circles">
        <template slot="no-more" v-if="!merchandiseProductStatus">{{
          $t("noMoreRecord")
        }}</template>
      </infinite-loading>

      <div class="cntntLoad" v-if="loading">
        <img src="../assets/images/loader.gif" alt="loader" />
      </div>
  </div>
</template>

<script>
import ImageSpinner from "../components/Common/ImageSpinner";
import NoDataFound from "../components/Common/NoDataFound";
import { mapState, mapMutations, mapGetters } from "vuex";
import ListQuantity from "./ListQuantity";
import CopyIcon from "@/components/Icons/CopyIcon";
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import types from "../store/types";
export default {
  name: "HotDeals",
  watch: {
    goBack() {
      this.$router.go(-1);
    },
  },
  components: {
    ImageSpinner,
    NoDataFound,
    CopyIcon,
    ListQuantity,
  },
  data() {
    return {
      pageIndex: 0,
      type: "TRENDING",
      merchandiseProductList: [],
      trendingProductList: [],
      title: "",
      loading: false,
      noRecord: false,
      merchandiseProductStatus: false,
      MerchantId: "",
    };
  },
  computed: {
    ...mapGetters(["couponResponse", "cartSize"]),
  },
  methods: {
    getUpdatedCartCount() {
      this.$store.commit(
        types.UPDATE_CART_SIZE,
        Math.round(parseInt(this.cartSize) + 1)
      );
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    goToProductDetail(productSrId) {
      if (this.$route.query.shopid && this.$route.query.source) {
        this.$router.push(
          "/detail/" +
            productSrId +
            "?source=" +
            this.$route.query.source +
            "&shopid=" +
            this.$route.query.shopid
        );
      } else if (this.$route.query.shopid) {
        this.$router.push(
          "/detail/" +
            productSrId +
            "?source=MERCHANDISE_PRODUCT" +
            "&shopid=" +
            this.$route.query.shopid
        );
      } else {
        this.$router.push(
          "/detail/" + productSrId + "?source=MERCHANDISE_PRODUCT"
        );
      }
    },
    getProductsListing($state) {
      this.loading = true;
      if (this.$store.getters.merchandisePageIndex) {
        this.pageIndex = this.$store.getters.merchandisePageIndex;
      }
      if (this.pageIndex > 0) {
        localStorage.removeItem("LandOnCategoryListingPage");
      }
      let payloadObject;
      if (this.$route.query.shopid) {
        payloadObject = this.pageIndex + "?shopid=" + this.$route.query.shopid;
      } else {
        payloadObject = this.pageIndex;
      }
      this.$store
        .dispatch({
          type: "getProductByMerchandiseType",
          payload: "PRODUCT",
          index: payloadObject,
        })
        .then((data) => {
          this.title = data.data.title;
          this.$store.commit("saveMerchandiseFilterData", {
            prodListTitle: this.title,
          });
          if (data.data.productListingDTOs.length > 0) {
            this.pageIndex += 1;
            this.merchandiseProductList.push(...data.data.productListingDTOs);
            this.$store.commit("saveMerchandiseData", {
              merchandiseProdList: this.merchandiseProductList,
              merchandisePageIndex: this.pageIndex,
            });
            this.loading = false;
            this.merchandiseProductStatus = false;
            $state && $state.loaded();
            if (
              this.$route.query.source === "LUCKY_WHEEL_SCRATCH" &&
              localStorage.getItem("LandOnCategoryListingPage")
            ) {
              this.getCategoryTracking("LUCKY_WHEEL_SCRATCH_NO_ITEMS");
            } else if (
              this.$route.query.source === "DAILY_LUCKY_SCRATCH" &&
              localStorage.getItem("LandOnCategoryListingPage")
            ) {
              this.getCategoryTracking("DAILY_LUCKY_SCRATCH_NO_ITEMS");
            } else if (
              this.$route.query.source === "FUTURE_LUCKY_SCRATCH" &&
              localStorage.getItem("LandOnCategoryListingPage")
            ) {
              this.getCategoryTracking("FUTURE_LUCKY_SCRATCH_NO_ITEMS");
            }
          } else {
            if (this.merchandiseProductList.length === 0) {
              this.merchandiseProductStatus = true;
            }
            this.loading = false;
            $state && $state.complete();
            if (
              this.$route.query.source === "LUCKY_WHEEL_SCRATCH" &&
              localStorage.getItem("LandOnCategoryListingPage")
            ) {
              this.getCategoryTracking("LUCKY_WHEEL_SCRATCH_NO_ITEMS");
            } else if (
              this.$route.query.source === "DAILY_LUCKY_SCRATCH" &&
              localStorage.getItem("LandOnCategoryListingPage")
            ) {
              this.getCategoryTracking("DAILY_LUCKY_SCRATCH_NO_ITEMS");
            } else if (
              this.$route.query.source === "FUTURE_LUCKY_SCRATCH" &&
              localStorage.getItem("LandOnCategoryListingPage")
            ) {
              this.getCategoryTracking("FUTURE_LUCKY_SCRATCH_NO_ITEMS");
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    getCategoryTracking(sourceValue) {
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "add-user-traking/?orderSourceType=" + sourceValue,
        "post"
      )
        .then((data) => {})
        .catch((err) => {
          console.log(err);
        });
    },
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    localStorage.setItem("LandOnBannerListingPage", true);
    if (this.$store.getters.prodListTitle) {
      this.title = this.$store.getters.prodListTitle;
    }
    if (
      this.$store.getters.merchandiseProdList &&
      this.$store.getters.merchandiseProdList.length > 0 &&
      this.$store.getters.merchandisePageIndex
    ) {
      this.merchandiseProductList = this.$store.getters.merchandiseProdList;
      this.pageIndex = this.$store.getters.merchandisePageIndex;
    } else {
      this.pageIndex = 0;
      this.$store.commit("saveMerchandiseData", {
        merchandisePageIndex: this.pageIndex,
      });
    }
    if (this.merchandiseProductList.length == 0) {
      this.loading = true;
    } else {
      this.loading = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.productListing .detail_content .main_customHeading.topZero {
  top: 0;
}
.productListing .detail_content .main_customHeading.topHeight {
  top: 44px;
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
p.product-name {
  font-size: 0.87em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  white-space: nowrap;
  margin-bottom: 5px;
}
.sortOption {
  color: #0091ff;
}
.noFilter {
  padding-top: 35px;
}
.paddingTop,
.productListing .detail_content.paddingTop {
  padding-top: 0;
}
.productListing .detail_content.paddingMore {
  padding-top: 80px;
}
</style>